@if (!isTablet && !isGroupsetQuery) {
<h3 [innerHtml]="'customSearch.title' | cxTranslate : { count: count, query: searchBoxQuery }"></h3>
} @if (!isTablet && isGroupsetQuery) {
<h3 [innerHtml]="'customSearch.titleForGroupset' | cxTranslate : { count: count }"></h3>
} @if (isTablet && !isGroupsetQuery) {
<h3 [innerHtml]="'customSearch.tabletTitle' | cxTranslate : { count: count, query: searchBoxQuery }"></h3>
} @if (isTablet && isGroupsetQuery) {
<h3 [innerHtml]="'customSearch.tabletTitleForGroupset' | cxTranslate : { count: count }"></h3>
} @if (isTablet && (isCustomTranslationsEnabled$ | async) !== null) {
<span
  [innerHtml]="
    'customSearch.tabletCount'
      | cxTranslate
        : {
            count: count,
            context: setCustomContext(
              isCustomTranslationsEnabled$ | async,
              activeCountry$ | async,
              activeLanguage$ | async
            )
          }
  "
></span>
}
